class DatabaseGasketMaterial {
    constructor() {
        this.gasketMaterials = [
            {
                name: "Non Metallic 3.2 mm",
                y_N_mm2: 11.04,
                m: 2,
                y_psi: 1600
            },
            {
                name: "Non Metallic 1.6 mm",
                y_N_mm2: 25.53,
                m: 2.75,
                y_psi: 3700
            },
            {
                name: "Non Metallic 0.8 mm",
                y_N_mm2: 44.85,
                m: 3.5,
                y_psi: 6500
            },
            {
                name: "Spiral Wound SS-304/316/321/Monel",
                y_N_mm2: 69,
                m: 3,
                y_psi: 10000
            },
            {
                name: "Rough Metallic Jacket Carbon Steel",
                y_N_mm2: 31.05,
                m: 3,
                y_psi: 4500
            },
            {
                name: "Rough Metallic Jacket Stainless Steel",
                y_N_mm2: 44.85,
                m: 3.5,
                y_psi: 6500
            },
            {
                name: "Rough Metallic Jacket Monel",
                y_N_mm2: 37.95,
                m: 3.25,
                y_psi: 5500
            },
            {
                name: "Smooth Metallic Jacket Carbon Steel",
                y_N_mm2: 52.44,
                m: 3.75,
                y_psi: 7600
            },
            {
                name: "Smooth Metallic Jacket Stainless Steel",
                y_N_mm2: 62.1,
                m: 3.75,
                y_psi: 9000
            },
            {
                name: "Smooth Metallic Jacket Monel",
                y_N_mm2: 55.2,
                m: 3.5,
                y_psi: 8000
            }
        ];
    }
}

export default DatabaseGasketMaterial;
